import MerchantMenuItemCreatePage from '../../../components/merchant/inventory/create/MerchantMenuItemCreatePage'

export default function MenuItemCreate() {
  return <MerchantMenuItemCreatePage />
}
